<template>
  <div id="mntQuestion">
    <div v-if="$route.path == '/storemnt/mntquestion'" style="width: 100%;height:100% ">
      <list-tree :categoryData="categoryData"
                 :categoryTreeData="categoryData"
                 @addcheck-treedata="getTreeCheckDataCategory"
                 @add-node="addNode"
                 @edit-node="editNode"
                 @remove-node="deleteNode"
                 @child-event="getfilterText"
                 :checkCategoryId="pcid"
                 :oneNodeArr="openData"
                 labelName="problemCategory">
      </list-tree>
      <el-dialog
        :title="$t('LanguageLib.MNT_QUESTION_CATEGORY_INFO')"
        :visible.sync="dialogVisible"
        top="20%"
        width="20%"
        :before-close="handleClose">
        <p><span style="color: red">*</span>{{$t('LanguageLib.MNT_QUESTION_CATEGORY_NAME')}}</p>
        <el-input style="min-width: 200px;width:220px;display: inline-block"
                  :placeholder="$t('LanguageLib.PleaseEnter')"
                  v-model="newMntCategoryName"
                  @change="inputCategory"
                  maxlength="50">
        </el-input>
        <el-select style="display: inline-block;width: 122px" v-model="currentLang"
                   @change="changeLanguage"
                   :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
          <span slot="prefix" v-if="currentLang===OwnerLanguage" style="position: relative;top: 25%;color: red">*</span>
          <el-option
            v-for="item in langList"
            :key="item.id"
            :label="item.content"
            :value="item.id"
          >
            <div><span style="color: red" v-if="item.id===OwnerLanguage">*</span>
              <span v-else style="visibility: hidden">*</span>
              {{item.content}}
            </div>
          </el-option>
        </el-select>
        <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{$t('LanguageLib.CANCEL')}}</el-button>
        <el-button type="primary" :loading="saveNodeLoading"
                   @click="confirmAddNode">{{$t('LanguageLib.DETERMINE')}}</el-button>
        </span>
      </el-dialog>
      <div class="right">
        <div class="operation">
          <div class="operationBtn">
            <el-button type="primary" @click="deleteMntQuestion" :disabled="batchDisabled">
              {{$t('LanguageLib.DELETE')}}
            </el-button>
            <el-button type="primary" @click="addMntQuestion" :disabled="addDisabled">
              {{$t('LanguageLib.ADD_TO')}}
            </el-button>
            <el-dropdown trigger="click">
              <el-button :loading="loadingExport" type="primary">{{$t('LanguageLib.ImportOrExport')}}</el-button>
              <el-dropdown-menu slot="dropdown">
                <!--                下载维修问题模板-->
                <el-dropdown-item :title="$t('LanguageLib.EXPORT_MNT_QUESTION')" @click.native.prevent="Export(2)">
                  {{$t('LanguageLib.DOWNLOAD_MNT_QUESTION_TEMPLATE')}}
                </el-dropdown-item>
                <!--                导入维修问题-->
                <el-dropdown-item :title="$t('LanguageLib.IMPORT')+$t('LanguageLib.MNT_QUESTION')">
                  <el-upload
                    class="upload"
                    name="files"
                    :data="formData"
                    :action="uploadApi"
                    :headers="headers()"
                    :on-preview="handlePreview"
                    :before-upload="beforeMntQuestionUpload"
                    :on-error="onError"
                    :on-success="onSuccess"
                    :show-file-list="false"
                    accept=".xlsx, .xls">
                    <el-button :plain="true" style="padding: 0px;border: none;color: #666;">
                      {{$t('LanguageLib.IMPORT')+$t('LanguageLib.MNT_QUESTION')}}
                    </el-button>
                  </el-upload>
                </el-dropdown-item>
                <!--                导出维修问题-->
                <el-dropdown-item :title="$t('LanguageLib.EXPORT_MNT_QUESTION')" @click.native.prevent="Export(0)">
                  {{$t('LanguageLib.EXPORT_MNT_QUESTION')}}
                </el-dropdown-item>
                <!--                下载分类多语言模板-->
                <el-dropdown-item :title="$t('LanguageLib.EXPORT_MNT_QUESTION_CATEGORY')"
                                  @click.native.prevent="Export(3)">
                  {{$t('LanguageLib.DOWNLOAD_MNT_QUESTION_CATEGORY_TEMPLATE')}}
                </el-dropdown-item>
                <!--                导入分类多语言-->
                <el-dropdown-item :title="$t('LanguageLib.IMPORT')+$t('LanguageLib.MNT_QUESTION_CATEGORY')">
                  <!--                  导入维修问题分类-->
                  <el-upload
                    class="upload"
                    name="files"
                    :data="formData"
                    :action="uploadApi"
                    :headers="headers()"
                    :on-preview="handlePreview"
                    :before-upload="beforeMntQuestionCategoryUpload"
                    :on-error="onError"
                    :on-success="onSuccess"
                    :show-file-list="false"
                    accept=".xlsx, .xls">
                    <el-button :plain="true" style="padding: 0px;border: none;color: #666;">
                      {{$t('LanguageLib.IMPORT')+$t('LanguageLib.MNT_QUESTION_CATEGORY')}}
                    </el-button>
                  </el-upload>
                </el-dropdown-item>
                <!--                导出分类多语言-->
                <el-dropdown-item :title="$t('LanguageLib.EXPORT_MNT_QUESTION_CATEGORY')"
                                  @click.native.prevent="Export(1)">{{$t('LanguageLib.EXPORT_MNT_QUESTION_CATEGORY')}}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="operationSearch">
          <span v-show="isSearch" style="color:#666;font-size:14px;">{{$t('LanguageLib.SearchedOut')}}<span
            class="colorG"> &nbsp;</span>{{$t('LanguageLib.Results')}}</span>
            <i v-show="isSearch" @click="clearSearchData" class="el-icon-close"
               style="margin:0 10px 0 10px;color:#666;font-size:14px;cursor: pointer;"></i>
            <el-input
              prefix-icon="el-icon-search"
              v-model="search"
              @keyup.enter.native="searchCategoryList">
            </el-input>
          </div>
        </div>
        <div class="tableParent">
          <el-table
            empty-text=" "
            class="table-fixed"
            :data="tableData"
            stripe
            @selection-change="selectionChange"
            @sort-change='sortChange'
            :default-sort="defaultSort"
            ref="table"
            style="width: auto;"
            v-loading="loading"
            height="100%">
            <!--勾选框-->
            <el-table-column
              type="selection"
              width="45">
            </el-table-column>

            <!--序号-->
            <el-table-column
              prop="sortNo"
              :label="$t('LanguageLib.SERIAL_NUMBER')"
              sortable="custom"
              min-width="200">
            </el-table-column>

            <!--维修问题名称-->
            <el-table-column
              prop="problemMemo_EN"
              :label="$t('LanguageLib.MNT_QUESTION_NAME')"
              min-width="300">
              <template slot-scope="scope">
                <el-tooltip effect="light" placement="top-start">
                  <span slot="content">{{scope.row.problemMemo_EN}}</span>
                  <span ref="toolTipItem"
                        style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;"
                  >{{scope.row.problemMemo_EN}}</span>
                </el-tooltip>
              </template>
            </el-table-column>

            <!--维修故障分类名称-->
            <el-table-column
              prop="problemCategoryName"
              :label="$t('LanguageLib.MNT_QUESTION_CATEGORY_NAME')"
              min-width="200">
            </el-table-column>

            <!--默认优先级-->
            <el-table-column
              prop="defaultPriorityName"
              :label="$t('LanguageLib.DEFAULT_PRIORITY')"
              min-width="200">
            </el-table-column>

            <!--操作按钮-->
            <el-table-column
              fixed="right"
              :label="$t('LanguageLib.Operation')"
              min-width="120">
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="editMntQuestion(scope.row, scope.$index, tableData)"
                  :title="$t('LanguageLib.Edit')"
                  type="text"
                  style="color:#fff;width:30px;height:30px;background-color:#3bc6b9;border-radius:50%;line-height:30px;padding:0;">
                  <i class="iconfont">&#xe60c;</i>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          :page-sizes="[20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal">
        </el-pagination>
      </div>
    </div>
    <router-view v-if="$route.path !== '/storemnt/mntquestion'"></router-view>
  </div>
</template>
<script>
import storeMntApi from '../../api/storeMnt'
import listTree from '@/components/listTree.vue'
import storeinformationApi from '../../api/storeinformation'
import baseUrl from '@/utils/base'

export default {
  name: 'mntQuestion',
  components: {
    listTree
  },
  data () {
    return {
      batchDisabled: true,
      addDisabled: true,
      EnumImportType: '',
      uploadApi: baseUrl.uploadApi, // 上传地址
      formData: { path: 'image' },
      saveNodeLoading: false,
      OwnerLanguage: '', // 公司默认语言
      langList: [], // 多语言数据源
      currentLang: '', // 当前选中的语言
      nodeType: '', // 编辑
      defaultSort: {
        prop: 'sortNo',
        order: 'ascending'
      }, // 默认排序
      prevSort: 'ascending', // 记录前一次的排序状态（elementUI默认有三种，即descending，ascending和null）
      prevProp: 'sortNo', // 记录前一次的prop值
      newMntCategoryName: '',
      mntId: '',
      editMntCategoryName: '', // 编辑分类名
      loading: false,
      editDialogVisible: false, // 编辑模式的dialog
      dialogVisible: false,
      multiLinguals: [],
      tableData: [], // 表格数据
      pageTotal: 0,
      isSearch: false,
      categoryData: [],
      openData: [], // 展开的数组
      loadingExport: false, // 导出按钮loading
      pcid: '0',
      isAsc: true, // 正序逆序
      search: '', // 搜索词
      sort: 1, // 排序
      pageIndex: 1,
      pageSize: 20,
      updataRouteQuery: () => {
        // 这是为了更新路由但是又不要刷新页面
        const query = this.$router.history.current.query
        const path = this.$router.history.current.path
        // newQuery是query的一个深拷贝
        const newQuery = JSON.parse(JSON.stringify(query))
        newQuery.pageIndex = this.pageIndex
        newQuery.pageSize = this.pageSize
        newQuery.search = this.$commonfun.encodeUrl(this.search)
        newQuery.sort = this.sort
        newQuery.isAsc = this.isAsc
        newQuery.NoRefresh = true
        this.$router.push({
          path,
          query: newQuery
        })
      },
      ProblemCategorySearch: '',
      getMntProblemList (pcid, isAsc, search, sort, pageIndex, pageSize) {
        let pcId
        if (pcid === '0') {
          pcId = null
        } else {
          pcId = pcid
        }
        storeMntApi.getMntProblemList('post', '/mnt/GetMntProblemList', {
          pcId,
          isAsc,
          search,
          sort,
          pageIndex,
          pageSize
        })
          .then(res => {
            this.tableData = res.data.data
            this.pageTotal = res.data.total
          }).catch(err => {
            this.$commonfun.console.log(err)
          })
      }
    }
  },
  created () {
    if (this.$route.query.fromPath) {
      // 接下来两行是把存储在url上的状态整个decode,再parse
      // 从而完整的读取状态机
      const query = JSON.parse(this.$commonfun.decodeUrl(this.$route.query.myQuery))
      this.pageIndex = query.pageIndex * 1// int型的隐式转换
      this.pageSize = query.pageSize * 1
      this.pcid = query.pcid
      this.search = query.search// 因为整个都decode又parse,所以不需要再decode了
      this.sort = query.sort
      this.sortOrder = query.sortOrder
      this.addDisabled = query.addDisabled
    }
    this.getMntProblemList(this.pcid, this.isAsc, this.search, this.sort, this.pageIndex, this.pageSize)
    this.getCategory()
    this.getLangList()
  },
  methods: {
    headers () {
      return {
        token: this.$commonfun.localStorage.getitem('token'),
        lang: this.$commonfun.localStorage.getitem('lang')
      }
    },
    handlePreview (file) {
    },
    // 导入维修问题
    beforeMntQuestionUpload (file) {
      this.EnumImportType = 7000
      const type = file.name.slice(file.name.lastIndexOf('.'), file.name.length)
      if (type !== '.xlsx' && type !== '.xls' && type !== '.XLSX' && type !== '.XLS') {
        this.$message.success(this.$t('LanguageLib.FILE_FORMAT_ERROR_PLEASE_UPLOAD_EXCAL'))
        return false
      }
    },
    // 导入维修问题分类
    beforeMntQuestionCategoryUpload (file) {
      this.EnumImportType = 22000
      const type = file.name.slice(file.name.lastIndexOf('.'), file.name.length)
      if (type !== '.xlsx' && type !== '.xls' && type !== '.XLSX' && type !== '.XLS') {
        this.$message.success(this.$t('LanguageLib.FILE_FORMAT_ERROR_PLEASE_UPLOAD_EXCAL'))
        return false
      }
    },
    // 上传失败
    onError (file) {
      this.$message.success(this.$t('LanguageLib.UPLOAD_FAILED'))
    },
    // 上传成功
    onSuccess (file, response) {
      const fileData = {
        FileName: '', // 文件名称
        FilePath: '', // 文件地址
        EnumImportType: '' //
      }
      fileData.FilePath = file[0]
      fileData.FileName = response.name
      fileData.EnumImportType = this.EnumImportType
      storeMntApi.importData('post', '/importinfo/create', fileData)
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('LanguageLib.FILE_ALREADY_UPLOAD_YOU_CAN_VIEW_IMPORT_ASSISTANT')
          })
          this.EnumImportType = ''
          this.updataRouteQuery()
          this.getMntProblemList(this.pcid, this.isAsc, this.search, this.sort, this.pageIndex, this.pageSize)
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    },
    confirmAddNode () {
      this.saveNodeLoading = true
      if (this.nodeType === 'add') {
        const newNode = {}
        const multiLinguals = this.multiLinguals
        newNode.problemCategoryName = ''
        for (let i = 0; i < multiLinguals.length; i++) {
          if (multiLinguals[i].ownerLanguage === this.OwnerLanguage) {
            newNode.problemCategoryName = multiLinguals[i].content
          }
        }
        newNode.multiLinguals = multiLinguals.map(x => {
          const y = {}
          y.ownerLanguage = x.ownerLanguage
          y.content = x.content
          return y
        })
        storeMntApi.createMntProblemCategory('post', '/Mnt/CreateMntProblemCategory', newNode)
          .then(res => {
            this.saveNodeLoading = false
            this.dialogVisible = false
            this.currentLang = this.OwnerLanguage
            this.changeLanguage()
            this.mntId = ''
            this.newMntCategoryName = ''
            this.multiLinguals = this.langList.map(x => {
              const y = {}
              y.content = ''
              y.ownerLanguage = x.id
              return y
            })
            this.getCategory()
          })
          .catch(err => {
            this.saveNodeLoading = false
            this.$commonfun.console.log(err)
          })
      } else {
        const editNode = {}
        const multiLinguals = this.multiLinguals
        editNode.pcid = this.mntId
        editNode.multiLinguals = multiLinguals
        storeMntApi.updateMntPromblemCategory('post', '/mnt/EditMntProblemCategory', editNode)
          .then(res => {
            this.saveNodeLoading = false
            this.dialogVisible = false
            this.currentLang = this.OwnerLanguage
            this.changeLanguage()
            this.mntId = ''
            this.newMntCategoryName = ''
            this.multiLinguals = this.langList.map(x => {
              const y = {}
              y.content = ''
              y.ownerLanguage = x.id
              return y
            })
            this.getCategory()
          })
          .catch(err => {
            this.saveNodeLoading = false
            this.$commonfun.console.log(err)
          })
      }
    },
    inputCategory (e) {
      // 每次打字都修改对应的语言的名字
      this.multiLinguals.forEach(x => {
        if (x.ownerLanguage === this.currentLang) {
          x.content = e
        }
      })
    },
    changeLanguage () {
      // 每次改语言,都把input框应该有的内容给读进去
      this.multiLinguals.forEach(x => {
        if (x.ownerLanguage === this.currentLang) {
          this.newMntCategoryName = x.content
        }
      })
    },
    getLangList () {
      // 获取店铺多语言列表
      storeinformationApi.getLang('get', '/BasicData/GetLang', {
        pageIndex: 1,
        pageSize: 2147483647
      })
        .then(res => {
          var OwnerLanguage = this.$commonfun.localStorage.getitem('OwnerLanguage') * 1
          this.OwnerLanguage = OwnerLanguage
          console.log(this.OwnerLanguage)
          this.langList = res.data
          this.multiLinguals = this.langList.map(x => {
            x.content = ''
            x.ownerLanguage = x.typeValue
            x.id = x.typeValue
            return x
          })
          this.langList = this.langList.map(x => {
            const obj = {}
            obj.id = x.typeValue
            obj.content = x.typeDes
            if (obj.id === OwnerLanguage) {
              this.currentLang = OwnerLanguage
            }
            return obj
          })
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    },
    addMntQuestion () {
      const x = {
        pcid: this.pcid,
        type: 'add',
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        search: this.search,
        sort: this.sort,
        isAsc: this.isAsc,
        addDisabled: this.addDisabled
      }
      this.$router.push({
        path: '/storemnt/mntquestion/editmntquestion',
        query: {
          myQuery: this.$commonfun.encodeUrl(JSON.stringify(x))
        }
      })
    },
    editMntQuestion (row, index, data) {
      const x = {
        pcid: this.pcid,
        mpid: row.id,
        type: 'edit',
        pageIndex: this.pageIndex,
        isAsc: this.isAsc,
        search: this.search,
        sort: this.sort,
        pageSize: this.pageSize,
        addDisabled: this.addDisabled
      }
      this.$router.push({
        path: '/storemnt/mntquestion/editmntquestion',
        query: {
          myQuery: this.$commonfun.encodeUrl(JSON.stringify(x))
        }
      })
    },
    handleClose () {
      this.newMntCategoryName = ''
      this.currentLang = this.OwnerLanguage
      this.dialogVisible = false
      this.multiLinguals = this.langList.map(x => {
        const y = {}
        y.content = ''
        y.ownerLanguage = x.id
        return y
      })
    },
    // 每页条数改变
    handleCurrentChange (val) {
      this.pageIndex = val
      // 请求列表接口数据
      this.updataRouteQuery()
      this.getMntProblemList(this.pcid, this.isAsc, this.search, this.sort, this.pageIndex, this.pageSize)
    },
    // 页数改变
    handleSizeChange (val) {
      this.pageSize = val
      // 请求列表接口数据
      this.updataRouteQuery()
      this.getMntProblemList(this.pcid, this.isAsc, this.search, this.sort, this.pageIndex, this.pageSize)
    },
    searchCategoryList () {
      this.pageIndex = 1
      this.updataRouteQuery()
      this.getMntProblemList(this.pcid, this.isAsc, this.search, this.sort, this.pageIndex, this.pageSize)
    },
    clearSearchData () {
      this.isSearch = false
      this.search = ''
      this.pageIndex = 1
      this.updataRouteQuery()
      this.getMntProblemList(this.pcid, this.isAsc, this.search, this.sort, this.pageIndex, this.pageSize)
    },
    editNode (e) {
      this.nodeType = 'edit'
      this.dialogVisible = true
      this.multiLinguals = e.data.multiLinguals
      this.mntId = e.id
      this.changeLanguage()
    },
    addNode (e) {
      this.nodeType = 'add'
      this.dialogVisible = true
    },
    deleteNode (e) {
      this.$commonfun.confirm(this.$t('LanguageLib.IS_DELETE_CATEGORY'), this.$t('LanguageLib.DELETE'), this.$t('LanguageLib.DETERMINE'), this.$t('LanguageLib.CANCEL'), false, 'warning', this)
        .then(() => {
          storeMntApi.deleteMntProblemCategory('get', '/Mnt/DeleteMntProblemCategory?pcid=' + e.id)
            .then(res => {
              this.$message({
                type: 'success',
                message: this.$t('LanguageLib.SUCCESSFULLY_DELETED')
              })
              this.getCategory()
            })
        })
    },
    // 树组件传来的数据
    getTreeCheckDataCategory (data) {
      if (data.id === '0') {
        this.pcid = null
        this.addDisabled = true
      } else {
        this.pcid = data.id
        this.addDisabled = false
      }
      this.updataRouteQuery()
      this.getMntProblemList(this.pcid, this.isAsc, this.search, this.sort, this.pageIndex, this.pageSize)
    },
    // 批量删除
    deleteMntQuestion (item) {
      const deleteList = this.selectedList
      this.$commonfun.confirm(this.$t('LanguageLib.IS_DELETE_QUESTION'), this.$t('LanguageLib.DELETE'), this.$t('LanguageLib.DETERMINE'), this.$t('LanguageLib.CANCEL'), false, 'warning', this)
        .then(() => {
          storeMntApi.deleteMntProblem('post', '/mnt/problem/remove', deleteList)
            .then(res => {
              if (res.data.failCount === 0) {
                this.$message({
                  type: 'success',
                  message: this.$t('LanguageLib.SUCCESSFULLY_DELETED')
                })
              } else {
                this.$message({
                  type: 'success',
                  message: this.$commonfun.stringFormat(this.$t('LanguageLib.SELECTED_ORGANIZATION_TO_STORE_INFO'), res.data.successCount, res.data.failCount, this.$t('LanguageLib.DELETE'), this.$t('LanguageLib.DELETE'))
                })
              }
              this.updataRouteQuery()
              this.getMntProblemList(this.pcid, this.isAsc, this.search, this.sort, this.pageIndex, this.pageSize)
            })
            .catch(err => {
              this.$commonfun.console.log(err)
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('LanguageLib.DeletionCancelled')
          })
        })
    },
    getCategory () {
      storeMntApi.getMntProblemCategorys('get', '/mnt/getMntProblemCategorys')
        .then(res => {
          this.categoryData = []
          const area = {
            problemCategory: this.$t('LanguageLib.ALL'),
            id: '0',
            childCategoryTrees: res.data
          }

          if (res.data.length > 0 && this.$route.query.fromPath === undefined) {
            // 'nextTick()' 下次dom更新时触发回调函数
            // 默认点击
            console.log('第一次进来')
            this.$nextTick().then(() => {
              if (document.querySelector('.el-tree-node__content')) {
                document.querySelector('.el-tree-node__content').click()
              }
            })
          }

          this.openData = res.data.map(x => x.id)
          this.categoryData.unshift(area)
        })
    },
    // 获取树组件传过来的模糊搜索条件
    getfilterText (value) {
      this.ProblemCategorySearch = value
    },
    // 导出
    Export (type) {
      this.loadingExport = true
      if (type === 0) {
        // 导出维修问题
        var pcid = (this.pcid === '0' || this.pcid === '') ? null : this.pcid
        storeMntApi.sysdomainExport('post', '/mnt/problem/export', {
          pcid: pcid,
          isAsc: this.isAsc,
          search: this.search,
          sort: this.sort,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        })
          .then(res => {
            this.$message({
              type: 'success',
              message: this.$t('LanguageLib.EXPORT_SUCCESSFULLY')
            })
            // 获取当前日期
            var today = new Date()
            var Month = today.getMonth() + 1
            var day = today.getDate()
            if (Month < 10) {
              Month = '0' + Month
            }
            if (day < 10) {
              day = '0' + day
            }
            var hours = today.getHours() < 10 ? '0' + today.getHours() : today.getHours()
            var minute = today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes()
            var second = today.getSeconds() < 10 ? '0' + today.getSeconds() : today.getSeconds()
            var milliSeconds = today.getMilliseconds()
            var currentDay = today.getFullYear() + '' + Month + '' + day + '' + hours + '' + minute + '' + second + '' + milliSeconds
            var filename = 'Mnt_issue' + '_' + currentDay + '.xlsx'
            var a = document.createElement('a')
            var url = window.URL.createObjectURL(new Blob([res.data]))
            a.href = url
            a.download = filename
            a.click()
            window.URL.revokeObjectURL(url)
            this.loadingExport = false
          })
          .catch(err => {
            this.loadingExport = false
            this.$commonfun.console.log(err)
          })
      } else if (type === 1) {
        storeMntApi.sysdomainExport('get', '/mnt/category/export', {
          searchValue: this.ProblemCategorySearch
        })
          .then(res => {
            this.$message({
              type: 'success',
              message: this.$t('LanguageLib.EXPORT_SUCCESSFULLY')
            })
            // 获取当前日期
            var today = new Date()
            var Month = today.getMonth() + 1
            var day = today.getDate()
            if (Month < 10) {
              Month = '0' + Month
            }
            if (day < 10) {
              day = '0' + day
            }
            var hours = today.getHours() < 10 ? '0' + today.getHours() : today.getHours()
            var minute = today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes()
            var second = today.getSeconds() < 10 ? '0' + today.getSeconds() : today.getSeconds()
            var milliSeconds = today.getMilliseconds()
            var currentDay = today.getFullYear() + '' + Month + '' + day + '' + hours + '' + minute + '' + second + '' + milliSeconds
            var filename = 'M_issue_category' + '_' + currentDay + '.xlsx'
            var a = document.createElement('a')
            var url = window.URL.createObjectURL(new Blob([res.data]))
            a.href = url
            a.download = filename
            a.click()
            window.URL.revokeObjectURL(url)
            this.loadingExport = false
          })
          .catch(err => {
            this.loadingExport = false
            this.$commonfun.console.log(err)
          })
      } else if (type === 2) {
        // 下载维修问题模板
        storeMntApi.downloadTemplate('get', '/basicdata/exceltemplate?template=13')
          .then(res => {
            this.$message({
              type: 'success',
              message: this.$t('LanguageLib.DOWNLOAD_SUCCESSFUL')
            })
            // 获取当前日期
            var currentDay = this.$commonfun.formatDate(new Date().toISOString(), '4')
            var filename = this.$t('LanguageLib.MNT_QUESTION_TEMPLATE') + '_' + currentDay + '.xlsx'
            var a = document.createElement('a')
            var url = window.URL.createObjectURL(new Blob([res.data]))
            a.href = url
            a.download = filename
            a.click()
            window.URL.revokeObjectURL(url)
            this.loadingExport = false
          })
      } else if (type === 3) {
        // 下载分类多语言模板
        storeMntApi.downloadTemplate('get', '/basicdata/exceltemplate?template=15')
          .then(res => {
            this.$message({
              type: 'success',
              message: this.$t('LanguageLib.DOWNLOAD_SUCCESSFUL')
            })
            // 获取当前日期
            var currentDay = this.$commonfun.formatDate(new Date().toISOString(), '4')
            var filename = this.$t('LanguageLib.MNT_QUESTION_CATEGORY_TEMPLATE') + '_' + currentDay + '.xlsx'
            var a = document.createElement('a')
            var url = window.URL.createObjectURL(new Blob([res.data]))
            a.href = url
            a.download = filename
            a.click()
            window.URL.revokeObjectURL(url)
            this.loadingExport = false
          })
      }
    },
    // 选择分类
    selectionChange (selection) {
      console.log(selection)
      this.selectedList = []
      for (let i = 0; i < selection.length; i++) {
        this.selectedList.push(selection[i].id)
      }
      if (this.selectedList.length === 0) {
        this.batchDisabled = true
      } else {
        this.batchDisabled = false
      }
    },
    // 列表排序
    sortChange (column) {
      console.log('点击了排序')
      if (column.order !== null) {
        this.prevSort = column.order
        if (column.order === 'ascending') {
          this.isAsc = true
          this.prevSort = 'ascending'
        } else if (column.order === 'descending') {
          this.isAsc = false
          this.prevSort = 'descending'
        }
        if (this.prevProp !== column.prop) {
          var columns = this.$refs.listPowerSupplyTab.columns.find(item => item.property === this.prevProp)
          columns.order = ''
        }
      }
      if (column.order === null) {
        column.column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        this.prevProp = column.prop
        this.prevSort = column.column.order
        this.isAsc = column.column.order !== 'descending'
      }
      switch (column.prop) {
        case 'sortNo':
          this.sort = 1
          break
        case 'updateDate':
          this.sort = 4
          break
      }
      // 请求列表接口数据
      this.updataRouteQuery()
      this.getMntProblemList(this.pcid, this.isAsc, this.search, this.sort, this.pageIndex, this.pageSize)
    }
  }
}
</script>

<style lang="scss">
  #mntQuestion {
    height: 100%;

    .redStar {
      color: red;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    .left {
      background: #fff;
      float: left;
      height: 100%;
      border-right: 1px solid #f2f2f2;

      .treeBox {
        height: calc(100% - 50px);
        overflow: auto;
        width: 100%;
      }

      .fifter {
        padding: 10px 0 10px 6%;
        line-height: 30px;

        .el-input {
          width: 60%;
        }

        .el-button--text {
          margin-left: 2.5%;
          padding: 2% 0;
          width: 20%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .right {
      width: 80%;
      margin-left: 20%;
      height: 100%;

      .cropper-content {
        background: #f2f2f2;
        padding-top: 20px;
        /*display: flex;
        display: -webkit-flex;
        justify-content: flex-end;
        -webkit-justify-content: flex-end;*/
        .cropper {
          width: 400px;
          height: 400px;
          margin: 0 auto;
        }

        .show-preview {
          flex: 1;
          -webkit-flex: 1;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          -webkit-justify-content: center;

          .preview {
            overflow: hidden;
            border-radius: 50%;
            border: 1px solid #cccccc;
            background: #cccccc;
            margin-left: 40px;
          }
        }
      }

      .footer-btn {
        padding-top: 20px;
        background: #f2f2f2;
        /*display: flex;
        display: -webkit-flex;
        justify-content: flex-end;
        -webkit-justify-content: flex-end;*/
        .scope-btn {
          width: 400px;
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;
          -webkit-justify-content: space-between;
          margin: 0 auto;

          span {
            display: block;
            float: left;
          }
        }

        .upload-btn {
          flex: 1;
          -webkit-flex: 1;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          -webkit-justify-content: center;
        }
      }

      .label-success {
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        -webkit-appearance: none;
        text-align: center;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        outline: 0;
        margin: 0;
        -webkit-transition: 0.1s;
        transition: 0.1s;
        font-weight: 500;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        padding: 12px 20px;
        font-size: 14px;
        border-radius: 4px;
        color: #fff;
        background-color: rgb(103, 194, 58) !important;
        border-color: rgb(103, 194, 58) !important;
      }

      .label-success:hover {
        background-color: rgb(133, 206, 97) !important;
        border-color: rgb(133, 206, 97) !important;
      }

      .dialogStoreComm {
        .el-dialog {
          width: 500px !important;
          height: 660px !important;

          .el-dialog__header {
            padding: 20px;
            border-bottom: 1px solid #EBEEF5;
          }

          .el-dialog__body {
            padding: 20px;
          }
        }
      }

      .showWithdraw {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #606266;
        line-height: 14px;
        margin-right: 25px;
        display: inline-block;
      }

      .operation {
        background: #fff;
        height: 30px;
        padding: 10px 0 10px 20px;
        border-bottom: 1px solid #f2f2f2;
        border-top: 1px solid #f2f2f2;

        .operationBtn {
          width: auto;
          display: inline-block;
          float: left;
          position: relative;

          .el-button {
            height: 30px;
            padding: 7px 20px;
          }

          .BatchSetting {
            background: #fff;
            color: #666666;
            position: absolute;
            left: 0;
            top: 30px;
            width: 100px;
            font-size: 14px;
            text-align: center;
            box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.2);
            border-radius: 2px;
            z-index: 99;

            li {
              line-height: 30px;
              cursor: pointer;
            }
          }

          .exportType {
            background: #fff;
            color: #666666;
            position: absolute;
            right: 0;
            top: 30px;
            min-width: 100px;
            font-size: 14px;
            text-align: center;
            box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.2);
            border-radius: 2px;
            z-index: 99;

            li {
              line-height: 30px;
              cursor: pointer;
              padding: 0 10px;
            }

            .upload {
              position: absolute;
              top: 30px;
              width: 100%;
              opacity: 0;

              .el-upload {
                width: 100%;

                button {
                  width: 100%;
                  padding-left: 0;
                }
              }
            }
          }
        }

        .operationSearch {
          float: right;
          padding-right: 51px;
          position: relative;

          .shaixuan {
            color: #999999;
            height: 15px;
            width: 15px;
            position: relative;
            top: 2px;
            margin-left: 10px;
            margin-right: 10px;
            font-weight: 600;
          }

          .shaixuan1 {
            color: #3BC6B9;
          }

          .el-input {
            width: 160px;

            .el-input__inner {
              height: 30px;
              line-height: 30px;
              border-radius: 20px;
            }
          }

          .el-icon-search {
            line-height: 30px;
          }
        }
      }

      .tableParent {
        height: calc(100% - 98px);
      }

      .el-pagination {
        padding: 8px 15px 5px;
        height: 35px;
        background: #fff;
      }
    }

    .drawerTitle {
      height: 25px;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(77, 77, 77, 1);
      line-height: 25px;
      margin-bottom: 20px;
    }

    .drawerText {
      height: 16px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(77, 77, 77, 1);
      line-height: 16px;
      margin-bottom: 5px;
    }

    .el-button--primary {
      background-color: #3BC6B9;
      color: #fff;
      border: none;
      margin-left: 10px;
    }

    .el-button--primary:hover {
      background-color: #3BC6B9;
      color: #fff;
      border: none;
    }

    /*.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
      background-color: #3BC6B9 !important;
      border-color: #3BC6B9 !important;
    }*/
    // 对于树组件配置特有的css
    .el-tree-node > .el-tree-node__children {
      overflow: unset;
    }

    .el-tree-node__content {
      /*overflow: hidden;*/
      /*text-overflow: ellipsis;*/
      font-size: 14px;
      height: 48px;
    }

    .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
      background-color: #F6F6F6
    }

    // .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content>span:last-child{
    //   color: #3BC6B9 !important;
    // }
    // .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content>ww-open-data{
    //   color: #3BC6B9 !important;
    // }
    // 更改表格的滚动条样式
    .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar,
    .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }

    .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-thumb,
    .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      background: #E1E1E1;
    }

    .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-track,
    .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track {
      border-radius: 5px;
      background: #fff;
    }

    // 抽屉组件样式修改
    .el-drawer.rtl {
      outline: none;
    }

    .el-drawer__wrapper {
      top: 172px;
      bottom: 18px;
      /*  right: 20px;*/
    }

    section.el-drawer__body {
      padding: 20px;

      .el-input {
        margin-bottom: 15px;
      }
    }

    .el-drawer__container {
      outline: none;
    }

    .colorG {
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(59, 198, 185, 1);
      line-height: 20px;
    }

    .el-table .descending .sort-caret.descending {
    }

    .el-table .ascending .sort-caret.ascending {
      border-bottom-color: #3BC6B9;
    }

    .el-pager li.active {
      color: #3BC6B9;
    }

    .el-table__fixed-body-wrapper .el-table__body {
      padding-bottom: 10px;
    }

    .filterContent {
      height: calc(100% - 154px);
      overflow: hidden;
      overflow-y: auto;
    }

    .filterContent::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }

    .filterContent::-webkit-scrollbar-thumb {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      background: #E1E1E1;
    }

    .filterContent::-webkit-scrollbar-track {
      border-radius: 5px;
      background: #fff;
    }

    .el-table-column--selection {
      text-align: center !important;
    }

    .el-tooltip__popper.is-light {
      box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
      border: 1px solid #E4E7ED !important;
      background-color: #fff;
      color: #000;

      .popper__arrow {
        border-top-color: #E4E7ED;
        border: #E4E7ED;
      }

      .popper__arrow::after {
        border-top-color: #fff;
      }
    }
  }
</style>
